<template>
  <div>
    <a-button style="margin-bottom: 10px" type="primary" @click="fetch()">刷新列表 <a-icon type="retweet" /></a-button>
    <div>
      <label title="手机号" class="info">手机号</label><a-input style="max-width: 10%; margin-right: 20px" placeholder="手机号" v-model="username"/>
      <a-button type="primary" @click="forceRegist">注册</a-button>
      <span v-if="username"> <label title="默认密码" class="info">默认密码</label> {{ password }} </span>
    </div>
    <a-table :columns="columns"
             :dataSource="data"
             :loading="loading"
             :pagination="false"
             class="general-table"
             style="font-size: 12px !important; margin-top: 10px"
    >
      <div slot="permission_list" slot-scope="text, record">
        <a-checkbox-group :options="permissionList" v-model="record.permission_list" @change="onChange(record)" >
          <!--<span style="color: red" slot="label" slot-scope="{value}">{{value}}</span>-->
        </a-checkbox-group>
      </div>
    </a-table>
  </div>
</template>

<script>
const axios = require('axios')
export default {
  name: 'UserManage',
  data () {
    return {
      permissionList: [
        { label: '群列表', value: 'ChatroomManage' },
        { label: '客户列表', value: 'ClientManage' },
        { label: '设备列表', value: 'DeviceManage' },
        { label: '机器人列表', value: 'BotManage' },
        { label: '用户交易记录', value: 'BalanceManage' },
        { label: '数据概览', value: 'GeneralManage' },
        { label: '群黑名单管理', value: 'ChatroomBlackManage' },
        { label: '后台操作记录', value: 'LogManage' },
        { label: '用户管理', value: 'UserManage' },
        { label: '大客户管理', value: 'BizManage' },
        { label: '文件素材管理', value: 'MaterialManage' },
        { label: '供应商管理', value: 'ProviderManage' },
        { label: '我的用户', value: 'MyClient' }
      ],
      getUserUrlPostFix: 'ULogin/get_user_list',
      registUrlPostfix: 'ULogin/regist',
      setUserPermissionUrlPostFix: 'ULogin/set_user_permission',
      loading: false,
      username: '',
      data: [],
      columns: [{
        title: 'USERNAME',
        dataIndex: 'username'
      }, {
        title: '权限列表',
        dataIndex: 'permission_list',
        scopedSlots: { customRender: 'permission_list' }
      }]
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    getUserUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.getUserUrlPostFix
    },
    registUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.registUrlPostfix
    },
    setUserPermissionUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.setUserPermissionUrlPostFix
    },
    password: function () {
      return 'D' + this.username
    }
  },
  methods: {
    fetch () {
      this.loading = true
      axios.post(this.getUserUrl, {
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            console.log(data.data.content.user_list)
            this.data = data.data.content.user_list
            this.loading = false
            // console.log('dataList', dataList)
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    onChange (record) {
      axios.post(this.setUserPermissionUrl, {
        username: record.username,
        permission_list: record.permission_list,
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            record.permission_list = data.data.content.permission_list
            // console.log('dataList', dataList)
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    },
    forceRegist () {
      axios.post(this.registUrl, {
        username: this.username,
        password: this.password,
        force: true
      }).then((data) => {
        if (data.data.err_code === 0) {
          // login success
          // console.log('data.user.token:', data.data.content.user.token)
          // sessionStorage.token = data.data.content.user.token
          // this.registRes = '注册成功，正在跳转登录'
          // console.log('regist success')
          // this.$router.push('/ChatroomManage')
          window.alert('注册成功')
          this.username = ''
          this.fetch()
        } else if (data.data.err_code === 20029) {
          this.registRes = '手机号已注册'
          this.password = ''
          this.passwordAgain = ''
        } else if (data.data.err_code === 20003) {
          this.registRes = '该手机号暂不能注册'
          this.password = ''
          this.passwordAgain = ''
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
